<template>
  <div id="maindiv" class="layout" :style="{height:(screenHeight-80)+'px'}" >
    <Layout style="height: 100%">
      <Header>
        <div class="fbox fbox-jb">
          <div @click="back" class="back"><a-icon type="left" />返回课程</div>
          <div v-if="classInfo.name && videoInfo.knobble" class="color-white">{{classInfo.name}} - {{videoInfo.knobble}}</div>
          <div></div>
        </div>
      </Header>
      <Layout>
        <Content style="heught: 100%">
          <div class="video">
             <!--  -->
            <video :src="videoUrl" controls="controls" id='video' controlslist="nodownload" oncontextmenu = "return false" ></video>
          </div>
        </Content>
        <Sider collapsible :collapsed-width="50" v-model="isCollapsed" class="catalogue p-y-20 p-x-15">
          <!-- <Panel v-for="(item, index) in catalogue" :key='index' hide-arrow>
            {{item.name}}
            <div class="p-t-10" slot="content">
              <div v-for="(t, i) in item.knobble" :key="i">
                <div @click="changeVideo(t.objectId)">
                  <div class="color-white m-b-5" :class="t.isActive?'active':''">{{t.knobble}}</div>
                  <div style="color:#95989C;fontSize:14px">视频时长：{{t.duration}}</div>
                </div>
                <Divider />
              </div>
            </div>
          </Panel> -->
          <div v-if="!isCollapsed && videoInfo.summarize" class="row p-x-20 fbox fbox-ac fbox-jb color-white ell" @click="detail('summarize')">
            <div>课后重点总结</div>
            <tk-icon material color='#fff' size='24'>play_circle_outline</tk-icon>
          </div>
          <div v-if="!isCollapsed && videoInfo.ppt" class="row p-x-20 fbox fbox-ac fbox-jb color-white" @click="detail('ppt')">
            <div>PPT</div>
          </div>
          <div v-if="!isCollapsed && videoInfo.fodder" class="row p-x-20 fbox fbox-ac fbox-jb color-white" @click="detail('fodder')">
            <div>素材</div>
          </div>
          <div v-if="!isCollapsed && videoInfo.teaching" class="row p-x-20 fbox fbox-ac fbox-jb color-white" @click="detail('teaching')">
            <div>教案</div>
          </div>
          <div v-show="!isCollapsed && videoInfo.case" class="row p-x-20 fbox fbox-ac fbox-jb color-white" @click="detail('case')">
            <div>案例</div>
          </div>
        </Sider>
      </Layout>
    </Layout>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isAcademy: false,
      video: '',
      knobble: '', // 当前播放的小节
      classInfo: {},
      videoInfo: {},
      catalogue: [],
      knobbleObj: {},
      videoUrl: '',
      screenHeight: document.documentElement.clientHeight, // 屏幕高度
      screenWidth: document.documentElement.clientWidth,
      isCollapsed: false
    }
  },
  computed: {
    menuitemClasses: function () {
      return [
        'menu-item',
        this.isCollapsed ? 'collapsed-menu' : ''
      ]
    }
  },
  watch: {
    'screenHeight': function (val) { // 监听屏幕高度变化
      var oIframe = document.getElementById('maindiv')
      oIframe.style.height = (Number(val) - 40) + 'px'
    }
  },
  mounted () {
    var _this = this
    window.onresize = function () { // 定义窗口大小变更通知事件
      // if (document.documentElement.clientHeight < 800) {
      //   return
      // }
      _this.screenWidth = document.body.clientWidth
      _this.screenHeight = document.documentElement.clientHeight // 窗口高度
      // console.log(_this.screenWidth)
      if (_this.screenWidth < 992) {
        _this.isCollapsed = true
      } else {
        _this.isCollapsed = false
      }
    }
    var video = document.getElementById('video')
    video['disablePictureInPicture'] = true // disablePictureInPicture的属性改为true
    _this.init()
    _this.knobble = _this.$route.query.knobble
  },
  methods: {
    async init () {
      await this.getClassInfo()
    },
    back () {
      this.$router.go(-1)
    },
    async getClassInfo () { // 获取课程详细信息
      let res = await this.$tkParse.getData(`/classes/course/${this.$route.query.courseId}`, {
        params: {
          include: ['preinstallMajor']
        }
      })
      this.classInfo = res
      await this.getKnobble()
    },
    async getKnobble (arr) { // 获取章节
      let res = await this.$tkParse.getData(`/classes/knobble/${this.$route.query.knobbleId}`)
      if (res) {
        this.videoInfo = res
        this.videoUrl = res.video.url
      }
    },
    // async getChapter (arr) { // 获取章节
    //   let res = await this.$tkParse.get('/classes/chapter', {
    //     params: {
    //       where: {
    //         objectId: {
    //           $in: arr
    //         }
    //       }
    //     }
    //   })
    //   if (res) {
    //     let data = res.data.results
    //     for (let i in data) {
    //       let chapter = {
    //         name: data[i].chapter,
    //         knobble: []
    //       }
    //       chapter.knobble = await this.getKnobble(data[i].course)
    //       this.catalogue.push(chapter)
    //     }
    //   }
    // },
    // async getKnobble (id) { // 获取小节
    //   let res = await this.$tkParse.get('/classes/knobble', {
    //     params: {
    //       where: {
    //         objectId: {
    //           $in: id
    //         }
    //       }
    //     }
    //   })
    //   if (res) {
    //     res.data.results.forEach(item => {
    //       item.isActive = false
    //     })
    //     return res.data.results
    //   }
    // },
    // async changeKnobble () { // 切换小节
    //   let arr = this.catalogue
    //   if (this.knobble) { // 跳转到对应的小节
    //     arr.forEach(item => {
    //       item.knobble.forEach(t => {
    //         if (t.objectId === this.knobble) {
    //           this.knobbleObj = t // 更新当前小节对象
    //           t.isActive = true // 当前点击的小节，高亮
    //           this.videoUrl = t.video.url // 更换对应小节的视频路径
    //         } else {
    //           t.isActive = false // 其他小节取消高亮
    //         }
    //       })
    //     })
    //     this.catalogue = arr
    //   } else { // 默认没有学习进度，设置第一章第一小节当前播放
    //     this.knobbleObj = arr[0].knobble[0]
    //     this.knobble = arr[0].knobble[0].objectId
    //     arr[0].knobble[0].isActive = true
    //     this.videoUrl = arr[0].knobble[0].video.url
    //     this.catalogue = arr
    //   }
    // },
    detail (e) {
      let routeUrl = this.$router.resolve({
        path: '/resourcePage',
        query: { knobbleId: this.$route.query.knobbleId, status: e }
      })
      window.open(routeUrl.href, '_blank')
    },
    changeVideo (e) { // 目录点击回调
      this.knobble = e
    }
  }
}
</script>

<style lang="scss" scoped>
#maindiv{
  max-height: 100vh;
  ::v-deep{
    .ivu-layout-header{
      background: #000!important;
    }
    .ivu-layout{
      height: 100%;
    }
    .ivu-layout-content{
      height: 100%;
    }
    .ivu-layout-sider-zero-width-trigger,.ivu-layout-sider{
      background: #3F4449!important;
      // min-width: 280px !important;
      // width: 300px !important;
    }
    .ivu-divider-horizontal{
      margin: 10px 0;
    }
    .ivu-layout-sider-trigger-icon{
      transform: rotate(180deg);
    }
    .ivu-layout-sider-collapsed .ivu-layout-sider-trigger-icon{
      transform: rotate(0deg);

    }
  }
}
.catalogue{
  position: relative;
  ::v-deep{
    .ivu-layout-sider-trigger{
      position: absolute;
      left: 0;
      bottom: 0;
      background: #3F4449 !important;
    }
    .ivu-collapse-simple{
      background-color: #3F4449 !important;
    }
    .ivu-collapse{
      border: 1px solid #2F3236;
    }
    .ivu-collapse-content{
      background-color:#3F4449 ;
    }
    .ivu-collapse>.ivu-collapse-item{
      border-top: none;
      margin: 5px 0;
    }
    .ivu-collapse-header{
      background-color:#3F4449 ;
      color: #fff;
    }
  }
}
.back {
    color: #20b573;
    cursor: pointer;
  }
.video {
  height: 100%;
  position: relative;
  video {
    width: 100%;
    height: 100%;
  }
  .hint{
    position: absolute;
    left: 20px;
    bottom: 70px;
    & span{
      cursor: pointer;
    }
  }
}
.row{
  width: 100%;
  height: 53px;
  background-color: #2F3236 !important;
  margin-bottom: 16px;
  cursor: pointer;
}
@media(max-width: 992px) {
  .more,.about{
    display: none;
  }
}
.layout-con{
  height: 100%;
  width: 100%;
}
.menu-item span{
  display: inline-block;
  overflow: hidden;
  width: 69px;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
  transition: width .2s ease .2s;
}
.menu-item i{
  transform: translateX(0px);
  transition: font-size .2s ease, transform .2s ease;
  vertical-align: middle;
  font-size: 16px;
}
.collapsed-menu span{
  width: 0px;
  transition: width .2s ease;
}
.collapsed-menu i{
  transform: translateX(5px);
  transition: font-size .2s ease .2s, transform .2s ease .2s;
  vertical-align: middle;
  font-size: 22px;
}
</style>
